export const getLeadAttributes = `
  query getLeadAttributes {
    leadAttributes {
      value: schemaName
      label: attributeName
    }
  }
`;

export interface GetLeadAttributesType {
  leadAttributes: {
    schemaName: string;
    attributeName: string;
  }[];
}
